// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/fonts/RigidicaText-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../public/fonts/RigidicaText-Light.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../public/fonts/RigidicaText-Regular.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

body {
    background-color: rgb(255, 255, 255);
    margin: 0;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
}

.wrapper {
    width: 100%;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
}

.container {
    width: 95% !important;
}

.container1 {
    width: 95% !important;
}

.container2 {
    width: 95% !important;
    max-width: 760px;
}

.content-wrapper {
    flex: 1 0 auto;
    width: 100%;
    padding-bottom: 40px;
}

@font-face {
    font-family: "Rigidica Text Bold";
    src: local("Rigidica Text Bold"),
        url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff");
    font-weight: bold;
    font-style: normal;
}

@font-face {
    font-family: "Rigidica Text Light";
    src: local("Rigidica Text Light"),
        url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff");
    font-weight: bold;
    font-style: normal;
}

@font-face {
    font-family: "Rigidica Text Regular";
    src: local("Rigidica Text Regular"),
        url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff");
    font-weight: bold;
    font-style: normal;
}`, "",{"version":3,"sources":["webpack://./src/styles/Global.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,oCAAoC;IACpC,SAAS;IACT,iBAAiB;IACjB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,iCAAiC;IACjC;8DACkE;IAClE,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,kCAAkC;IAClC;8DACmE;IACnE,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,oCAAoC;IACpC;8DACqE;IACrE,iBAAiB;IACjB,kBAAkB;AACtB","sourcesContent":["* {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n}\n\nbody {\n    background-color: rgb(255, 255, 255);\n    margin: 0;\n    min-height: 100vh;\n    display: flex;\n    flex-direction: column;\n}\n\n.wrapper {\n    width: 100%;\n    min-height: 100vh;\n    display: flex;\n    flex-direction: column;\n}\n\n.container {\n    width: 95% !important;\n}\n\n.container1 {\n    width: 95% !important;\n}\n\n.container2 {\n    width: 95% !important;\n    max-width: 760px;\n}\n\n.content-wrapper {\n    flex: 1 0 auto;\n    width: 100%;\n    padding-bottom: 40px;\n}\n\n@font-face {\n    font-family: \"Rigidica Text Bold\";\n    src: local(\"Rigidica Text Bold\"),\n        url(\"../../public/fonts/RigidicaText-Bold.otf\") format(\"woff\");\n    font-weight: bold;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: \"Rigidica Text Light\";\n    src: local(\"Rigidica Text Light\"),\n        url(\"../../public/fonts/RigidicaText-Light.otf\") format(\"woff\");\n    font-weight: bold;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: \"Rigidica Text Regular\";\n    src: local(\"Rigidica Text Regular\"),\n        url(\"../../public/fonts/RigidicaText-Regular.otf\") format(\"woff\");\n    font-weight: bold;\n    font-style: normal;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
